import React, { useState } from "react";
import MileStoneCloumn from "./MileStoneCloumn";
import AllInfo from "./AllInfo";
import NoData from "./NoData";
import AllHeading from "./AllHeading";

const ProjectCloumn = ({ project, milestones = [] }) => {
  const [status, setStatus] = useState(false);

  return (
    <>
    <div className="projectcoloum">

      <AllInfo
        all={project}
        status={status}
        setStatus={setStatus}
        componentName={"project"}
      />
    </div>

      {status && (
        <>
          {milestones.length > 0 ? (
            <>
              <AllHeading>Milestones</AllHeading>
              {milestones.map((milestone, mileIndex) => (
                <MileStoneCloumn
                  key={mileIndex}
                  milestones={milestone}
                  mileIndex={mileIndex}
                />
              ))}
            </>
          ) : (
            <NoData>📌 No milestones</NoData>
          )}
        </>
      )}
    </>
  );
};

export default ProjectCloumn;
